
/* Navigation configuration */
const nav = {
  home: 'Home',
  courts: 'Courts',
  sessions: 'Sessions',
  learning: 'Learning',
  scoreboard: 'Scoreboard',
  login: 'Login',
  signup: 'Signup'
};

/* Footer configuration */
const footer = {
  description: "Join Hong Kong's premier pickleball community. Connect with players, book courts, and improve your game with HKPicklePlay.",
  quickLinks: 'Quick Links',
  contact: 'Contact',
  sendMessage: 'Send Message'
};

/* Auth pages */
const auth = {
  // Login page
  welcome_back: 'Welcome back',
  sign_in_subtitle: 'Sign in to your pickleball community account',
  email_address: 'Email address',
  password: 'Password',
  remember_me: 'Remember me',
  forgot_password: 'Forgot password?',
  sign_in: 'Sign in',
  signing_in: 'Signing in...',
  or_continue_with: 'Or continue with',
  google: 'Google',
  apple: 'Apple',
  no_account: "Don't have an account?",
  sign_up_free: 'Sign up for free',
  enter_email: 'Enter your email',
  enter_password: 'Enter your password',
  
  // Signup page
  join_community: 'Join the community',
  create_account_subtitle: 'Create your pickleball community account',
  nickname: 'Nickname',
  confirm_password: 'Confirm Password',
  choose_nickname: 'Choose a nickname',
  create_password: 'Create a password',
  confirm_your_password: 'Confirm your password',
  password_min_length: 'Must be at least 6 characters',
  agree_terms: 'I agree to the',
  terms_of_service: 'Terms of Service',
  and: 'and',
  privacy_policy: 'Privacy Policy',
  create_account: 'Create account',
  creating_account: 'Creating account...',
  or_sign_up_with: 'Or sign up with',
  already_have_account: 'Already have an account?',
  sign_in_here: 'Sign in here',
  
  // Error messages
  passwords_not_match: 'Passwords do not match',
  password_min_6_chars: 'Password must be at least 6 characters',
  agree_terms_required: 'Please agree to the terms and conditions',
  account_created_success: 'Account created successfully! You can now sign in.',
  
  // Social auth not available
  social_auth_unavailable: 'Social authentication is currently unavailable. Please use email and password to sign in.'
};

export const common = {
  nav,
  footer,
  auth,
  
  // Common actions
  search: 'Search',
  filter: 'Filter',
  book: 'Book',
  create: 'Create',
  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  view: 'View',
  details: 'Details',
  close: 'Close',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  
  // Language
  language: 'Language',
  english: 'English',
  traditional_chinese: '繁體中文'
};

export default common;
